/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated.js';
import { createLN10 } from '../../factoriesAny.js';
export var LN10Dependencies = {
  BigNumberDependencies,
  createLN10
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesLN10.generated.js
// module id = 1390
// module chunks = 2